<div class="bg-prim" data-aos="fade">
  <div class="container">
    <div class="row">
      <a href="https://www.facebook.com/ArgonBand1/" target="_blank"
        class="col-3 text-center py-4 social-icon d-block no-line"><span class="icon-facebook text-white"></span></a>
      <a href="https://www.instagram.com/argon_the_band/" target="_blank"
        class="col-3 text-center py-4 social-icon d-block no-line"><span class="icon-instagram text-white"></span></a>
      <a href="https://www.youtube.com/channel/UC1yOYb0au3cu8igvAkuftWA" target="_blank"
        class="col-3 text-center py-4 social-icon d-block no-line"><span class="icon-youtube text-white"></span></a><a
        href="https://www.tiktok.com/@argon.band" target="_blank"
        class="col-3 text-center py-4 social-icon d-block no-line"><span class="icon-tiktok text-white"> </span></a>
    </div>
  </div>
</div>

<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="center-footer-content">
        <h3 class="footer-heading text-center">About Argon</h3>
        <p>
          We are an alternative rock band based in Landen, Belgium. we play a
          mix of covers and originals!
        </p>
        <br />
        <p>
          contact:
          <a href="mailto:contact&#64;argon.band">contact&#64;argon.band</a>
        </p>
      </div>
    </div>
  </div>
</footer>